import { Link } from 'react-router-dom';
import React, { Component } from 'react';

export class Menu extends React.Component {
  render() {
    let className = "m-menu__item ";
    let { path, title } = this.props;
    className += window.location.pathname == path ? "m-menu__item--active" : "";
    return (
      <li className={className} {...this.props}>
        <Link to={path} className="m-menu__link m-menu__toggle" >
          <span className="m-menu__item-here"></span>
          <span className="m-menu__link-text">{title}</span>
        </Link>
      </li>
    )
  }
}
export class BadgeMenu extends React.Component {
  render() {
    let { value, title, onClick, className } = this.props;
    return (
      <li className="m-menu__item">
        <a className="m-menu__link btn" onClick={onClick}>
          <span className="m-menu__link-text">{title}</span>
          <span className="m-menu__link-badge">
            <span className={className}>
              {value}
            </span>
          </span>
        </a>
      </li >
    )
  }
}

export class Content extends React.Component {

  render() {
    return (<div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">
      <button className="m-aside-left-close m-aside-left-close--skin-light" id="m_aside_left_close_btn">
        <i className="la la-close"></i>
      </button>
      <div id="m_aside_left" className="m-grid__item m-aside-left ">
        <div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light " data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">
          <ul className="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
            <li className="m-menu__section">
              <h4 className="m-menu__section-text">{this.props.title}</h4>
              <i className="m-menu__section-icon flaticon-more-v3"></i>
            </li>
            {this.props.state.leftMenu && this.props.state.leftMenu()}
          </ul>
        </div>
      </div>
      <div className="m-grid__item m-grid__item--fluid m-wrapper">
        <div className="m-subheader ">
          <div className="d-flex align-items-center">
            <div className="mr-auto">
              <h3 className="m-subheader__title m-subheader__title--separator">{this.props.title}</h3>
              <ul className="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li className="m-nav__item m-nav__item--home">
                  <Link to="/" className="m-nav__link m-nav__link--icon">
                    <i className="m-nav__link-icon la la-home"></i>
                  </Link>
                </li>
                <li className="m-nav__separator">- </li>
                {this.props.state.subMenu && this.props.state.subMenu()}
              </ul>
            </div>
            {
              this.props.state.state.page &&
              <Pagenation page={this.props.state.state.page} onClick={e => {
                let { page } = this.props.state.state;
                switch (e) {
                  case '-':
                    if (page.start != 0) {
                      page.start -= page.interval;
                      page.end -= page.interval;
                    }
                    break;
                  case '+':
                    page.start += page.interval;
                    page.end += page.interval;
                    break;
                }
                this.props.state.setState({ page });
              }} />}
          </div>
        </div>
        <div className="m-content">
          {this.props.state.content()}
        </div>
      </div>
    </div>)
  }
}


export class Pagenation extends Component {
  render() {
    return (
      <ul className="m-subheader__breadcrumbs m-nav m-nav--inline ml-auto">
        <li className="m-nav__separator"></li>
        <li className="m-nav__item">
          <button className="btn btn-primary"
            onClick={e => {
              this.props.onClick('-');
            }}><i className="fa fa-arrow-left" /></button>
        </li>
        <li className="m-nav__separator"></li>
        <li className="m-nav__item">
          <button className="btn"> {this.props.page.start + 1} - {this.props.page.end} </button>
        </li>
        <li className="m-nav__separator"></li>
        <li className="m-nav__item">
          <button className="btn btn-primary"
            onClick={e => {
              this.props.onClick('+');
            }}><i className="fa fa-arrow-right" /></button>
        </li>
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js